import Amplify, { Auth, Storage, API } from 'aws-amplify'
import { Navigate, Routes, Route } from "react-router-dom";
import 'semantic-ui-css/semantic.min.css'

import Welcome from './pages/Welcome';
import Home from './pages/Home';
import Browser from './pages/Browser';
import BorrowingAccount from './pages/BorrowingAccount';
import NewBorrowingAccount from './pages/NewBorrowingAccount';
import MemberTransactions from './pages/MemberTransactions';
import Register from './pages/Register';
import AccountManagement from './pages/AccountManagement';
import SubscriptionPlan from './pages/SubscriptionPlan';

import React, {Component, Fragment} from 'react';
import navigationHandler from './utilities/navigator.js';

function App (){

  return(
    <Routes>
      <Route path="" element={<Welcome />} />
      <Route path="/" element={<Welcome />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/home" element={<Home props={Home.routeProps}/>} />
      <Route path="/browser" element={<Browser props={Browser.routeProps}/>} />
      <Route path="/borrowingacct/:contractAddress" element={<BorrowingAccount props={BorrowingAccount.routeProps}/>} />
      <Route path="/newborrowingacct" element={<NewBorrowingAccount props={NewBorrowingAccount.routeProps}/>} />
      <Route path="/membertransactions" element={<MemberTransactions props={MemberTransactions.routeProps}/>} />
      <Route path="/register" element={<Register props={Register.routeProps}/>} />
      <Route path="/accountmanagement" element={<AccountManagement props={AccountManagement.routeProps}/>} />
      <Route path="/subscriptionplan" element={<SubscriptionPlan props={SubscriptionPlan.routeProps}/>} />
    </Routes>
  )
}
export default App;
